<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'User',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-user-settings-line',
  color: 'error',
  title: 'Kelola User',
  description: 'Membuat akun login untuk pegawai dan mengatur role-nya.',
  purpose: 'Panduan membuat, mengedit, menonaktifkan, dan menghapus akun User.',
  concept: [
    {
      icon: 'ri-user-line',
      title: 'User Beda dengan Pegawai (Employee)',
      text: 'Data Pegawai (Master Data) dan akun User (login) adalah dua hal terpisah di QUALIVA. Seorang Pegawai bisa saja belum punya akun User (belum bisa login), dan sebaliknya.',
    },
    {
      icon: 'ri-shield-user-line',
      title: 'Satu User Boleh Multi-Role',
      text: 'Berbeda dari sistem lama, satu akun User di QUALIVA boleh punya lebih dari satu Role sekaligus — misalnya seorang Kepala Unit yang juga menjabat PJ MFK.',
    },
  ],
  steps: [
    { title: 'Buka menu Administrasi → Users, klik "+ Tambah User"', detail: 'Isi Nama, Email, Password, dan pilih satu atau lebih Role.' },
    { title: 'Klik "Simpan"', detail: 'User bisa langsung login memakai email dan password yang dibuat.' },
    { title: 'Edit: klik ikon pensil pada baris User', detail: 'Bisa mengubah nama/email/role, atau mengosongkan password kalau tidak ingin menggantinya.' },
    { title: 'Nonaktifkan: klik toggle Status pada baris User', detail: 'User nonaktif tidak bisa login sama sekali, tapi data historisnya tetap tersimpan.' },
  ],
  warning: 'Anda tidak bisa menghapus akun Anda sendiri — ini mencegah instalasi kehilangan admin utamanya secara tidak sengaja.',
  tips: [
    'Gunakan email asli/format email yang jelas — memudahkan identifikasi user di Audit Log.',
    'Nonaktifkan, jangan hapus, akun pegawai yang cuti panjang — data historisnya tetap berguna.',
  ],
  faq: [
    { q: 'Bagaimana kalau pegawai lupa password?', a: 'Anda (admin) bisa mengedit akun pegawai tersebut dan mengisi password baru — pegawai tidak bisa mereset password sendiri, harus lewat admin.' },
  ],
  related: [
    { title: 'Kelola Role & Permission', sub: 'Atur hak akses tiap role', icon: 'ri-shield-keyhole-line', color: 'error', to: { name: 'help-administrasi-kelola-role' } },
    { title: 'Impersonate', sub: 'Login sebagai user lain untuk dukungan teknis', icon: 'ri-user-follow-line', color: 'error', to: { name: 'help-administrasi-impersonate' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
